import { useFind } from 'src/api/APIHooks';
import { groupBy, map } from 'lodash';
import {
  useCurrentProviderId,
  useCurrentPayerId,
  useIsCBOProvider,
  useIsPayer,
} from 'common/contexts/CurrentProviderContext';

const buildFeeScheduleProgramFilters = (isCBO, isPayer, providerId, payerId) => {
  const filters = {
    billable: true,
  };

  if (isCBO) {
    filters['programs.provider'] = providerId;
  } else if (isPayer) {
    filters['social_plans.payers'] = payerId;
  }

  return filters;
};

const useFeeScheduleProgramOptions = () => {
  const providerId = useCurrentProviderId();
  const payerId = useCurrentPayerId();
  const isCBO = useIsCBOProvider();
  const isPayer = useIsPayer();

  const filters = buildFeeScheduleProgramFilters(isCBO, isPayer, providerId, payerId);
  const isQueryEnabled = !!providerId && (isCBO || (isPayer && !!payerId));

  const { data } = useFind(
    'fee_schedule_programs',
    filters,
    {
      page: { size: Infinity },
      queryConfig: {
        enabled: isQueryEnabled,
        placeholderData: undefined,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
      },
    },
  );
  const groupByFSPName = groupBy(data?.data?.data ?? [], 'name');

  return map(groupByFSPName, (val, key) => ({
    label: key,
    value: map(val, 'id').join(','),
  }));
};

export default useFeeScheduleProgramOptions;
